import { AnswerStreamEvent } from './types';

type AnswerStreamSubscriber = (event: AnswerStreamEvent) => void;

const subscribers = new Set<AnswerStreamSubscriber>();

export function publishAnswerStreamEvent(event: AnswerStreamEvent): void {
  subscribers.forEach((subscriber) => subscriber(event));
}

export function subscribeToAnswerStream(
  subscriber: AnswerStreamSubscriber
): () => void {
  subscribers.add(subscriber);
  return () => subscribers.delete(subscriber);
}
